import * as React from 'react';
import { Fragment } from 'react';
import { BulkDeleteButton } from 'react-admin';
import {
  ArrowUpward,
  AttachMoney,
} from '@material-ui/icons';
import BulkAction from '../../bulk-action';
import { LICENSE_TYPES, PRICE_TIER } from '../../../constants';

const ProductsBulkActionButtons = (props) => (
  <Fragment>
    <BulkAction
      type="select"
      source="license_type"
      sourceName="License Type"
      icon={<ArrowUpward />}
      resource="artists"
      resourceLabel="Artists"
      options={LICENSE_TYPES}
      {...props}
    />
    <BulkAction
      type="select"
      source="price_tier"
      sourceName="Price Tier"
      icon={<AttachMoney />}
      resource="artists"
      resourceLabel="Artists"
      options={PRICE_TIER}
      {...props}
    />
    <BulkDeleteButton {...props} />
  </Fragment>
);

export default ProductsBulkActionButtons;
